import { SUCCESS_MODAL_TOGGLE, HSN, ON_BASIS, GST, WORNING_MODAL_TOGGLE, PROJECT_LIST, BUILDING_LIST, POC_DESIGNATION, VILLAGES_LIST, INVESTOR_TYPE, PERMISSION_TYPE, WATER_SUPPLY, ELECTRICITY_CONNECTION, USERDATA, USERID, REGISTRATION_SUCCESS_MODAL_TOGGLE, LOADER, CITY, CONSTITUTION, SUCCESSINFO, REDIRECTLINK, DOCNAMES_LIST, BUILDING_TYPE, GALA_LIST, FLOOR_TYPE, SOLD_GALA_LIST, LOT_INTENT, DGST, AGEMODAL, QUERY, RESELLREASON, USERPROJECT, PROFILEIMG, WORNING_MODAL_TOGGLE2, SENDFROMTYPE } from '../actions/Types'

const initialState = {
    successToggle: false,
    loader: false,
    registrationSuccessToggle: false,
    warningToggle: false,
    warningToggle2: false,
    deleteableId: 0,
    deleteableId2: 0,
    userid: undefined,
    projectList: undefined,
    buildingList: undefined,
    villagesList: undefined,
    investortype: undefined,
    permissiontype: undefined,
    watersupply: undefined,
    electricityconnection: undefined,
    cityList: undefined,
    constitutionList: undefined,
    successinfo: undefined,
    linkRedirect: undefined,
    docnameslist: undefined,
    pocdesnameslist: undefined,
    buildingtypes: undefined,
    galaList: undefined,
    soldGalaList: undefined,
    floorType: undefined,
    lotIntent: undefined,
    onBasisData: undefined,
    gstData: undefined,
    hsnData: undefined,
    dgst: 0,
    agemodalToggle: false,
    query: undefined,
    reason: undefined,
    userproject: undefined,
    userimg: undefined,
    sendFrom : [],
}

const ModalReducer = (state = initialState, action) => {
    switch (action.type) {
        case SUCCESS_MODAL_TOGGLE:
            return {
                ...state,
                successToggle: !state.successToggle
            }
        case REGISTRATION_SUCCESS_MODAL_TOGGLE:
            return {
                ...state,
                registrationSuccessToggle: !state.registrationSuccessToggle
            }

        case LOADER:
            return {
                ...state,
                loader: state.loader
            }

        case WORNING_MODAL_TOGGLE:
            return {
                ...state,
                warningToggle: !state.warningToggle,
                deleteableId: action.id
            }
        case WORNING_MODAL_TOGGLE2:
            return {
                ...state,
                warningToggle2: !state.warningToggle2,
                deleteableId2: action.id
            }
        case PROJECT_LIST:
            return {
                ...state,
                projectList: action.projectData
            }
        case BUILDING_LIST:
            return {
                ...state,
                buildingList: action.buildingData
            }
        case VILLAGES_LIST:
            return {
                ...state,
                villagesList: action.villagesData
            }
        case INVESTOR_TYPE:
            return {
                ...state,
                investortype: action.investortypeData
            }
        case ON_BASIS:
            return {
                ...state,
                onBasisData: action.onBasisData
            }
        case PERMISSION_TYPE:
            return {
                ...state,
                permissiontype: action.permissiontypeData
            }
        case WATER_SUPPLY:
            return {
                ...state,
                watersupply: action.watersupplyData
            }
        case ELECTRICITY_CONNECTION:
            return {
                ...state,
                electricityconnection: action.electricityconnectionData
            }
        case CITY:
            return {
                ...state,
                cityList: action.CityData
            }
        case CONSTITUTION:
            return {
                ...state,
                constitutionList: action.ConstitutionData
            }
        case USERID:
            return {
                ...state,
                userid: action.data
            }

        case SUCCESSINFO:
            return {
                ...state,
                successinfo: action.successInfoData
            }

        case REDIRECTLINK:
            return {
                ...state,
                linkRedirect: action.linkRedirectData
            }

        case DOCNAMES_LIST:
            return {
                ...state,
                docnameslist: action.docnameslistData
            }
        case POC_DESIGNATION:
            return {
                ...state,
                pocdesnameslist: action.PocDesignationData
            }
        case BUILDING_TYPE:
            return {
                ...state,
                buildingtypes: action.buildingTypeData
            }
        case GALA_LIST:
            return {
                ...state,
                galaList: action.galaData
            }
        case SOLD_GALA_LIST:
            return {
                ...state,
                soldGalaList: action.soldGalaData
            }
        case FLOOR_TYPE:
            return {
                ...state,
                floorType: action.floorTypeData
            }
        case LOT_INTENT:
            return {
                ...state,
                lotIntent: action.lotIntentData
            }
        case GST:
            return {
                ...state,
                gstData: action.gstData
            }
        case HSN:
            return {
                ...state,
                hsnData: action.hsnData
            }
        case DGST:
            return {
                ...state,
                dgst: action.dgst
            }
        case AGEMODAL:
            return {
                ...state,
                agemodalToggle: action.agemodaldata
            }
        case QUERY:
            return {
                ...state,
                query: action.query
            }
        case RESELLREASON:
            return {
                ...state,
                reasonList: action.reason
            }
        case USERPROJECT:
            return {
                ...state,
                userproject: action.userproject
            }
        case PROFILEIMG:
            return {
                ...state,
                userimg: action.userimg
            }
        case SENDFROMTYPE:
            return {
                ...state,
                sendFrom: action.data
            }
        default:
            return state;
    }
}

export default ModalReducer